import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import TopicCard from "@/components/feature/TopicCard";

export default function LatestGrid() {
  const latest = [...topics].sort((a, b) => (a.date < b.date ? 1 : -1));

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="flex items-center gap-2 font-label text-xs font-medium tracking-[0.2em] text-secondary-600">
              <i className="ri-archive-2-line"></i>
              最新聚合
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              最近归档的事件
            </h2>
          </div>
          <Link
            to="/list"
            className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 font-label text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
          >
            查看全部事件
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {latest.map((topic) => (
            <TopicCard key={topic.id} topic={topic} />
          ))}
        </div>
      </div>
    </section>
  );
}